export default "__VITE_ASSET__DS1$eQ_R__"